import { render, staticRenderFns } from "./TwentyTwenty.vue?vue&type=template&id=5a00f88e&"
import script from "./TwentyTwenty.vue?vue&type=script&lang=js&"
export * from "./TwentyTwenty.vue?vue&type=script&lang=js&"
import style0 from "./TwentyTwenty.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports